import { ErrorResponse } from '@/types/apiTypes';
import { makeFetch } from '@/data/helpers/makeFetch';
import { Method } from '@/data/enums/method';
import { QueryKey } from '@/data/enums/queryKeys';
import { Services } from '@/data/enums/services';
import { useAppContext } from '@/providers/AppContextProvider/AppContextProvider';
import { useMutation } from '@tanstack/react-query';

/** @apiRequestSchema AuthRequest */
type MutationProps = {
    password: string;
    recaptchaToken: string;
    username: string;
};

type LoginResponse = {
    token: string;
};

export const usePostLogin = () => {
    const { deployment } = useAppContext();

    return useMutation<LoginResponse | ErrorResponse, Error, MutationProps>({
        mutationFn: (body) =>
            makeFetch<LoginResponse>({
                apiPath: 'api/auth',
                apiService: Services.Local,
                body,
                deployment,
                method: Method.Post,
                token: '',
            }),
        mutationKey: [QueryKey.Login],
    });
};
